import { Key, PropsWithChildren, createContext, useMemo } from "react";

import { InputChoicesContextValue } from "./InputChoicesContext.decl";

export const InputChoicesContext =
  createContext<InputChoicesContextValue<any> | null>(null);

export function InputChoicesContextProvider<Value extends Key>({
  value,
  mode,
  onChange,
  children,
}: PropsWithChildren<InputChoicesContextValue<Value>>) {
  const contextValue = useMemo(
    () => ({ value, mode, onChange }),
    [mode, onChange, value]
  );

  return (
    <InputChoicesContext.Provider value={contextValue}>
      {children}
    </InputChoicesContext.Provider>
  );
}
